<template>
    <div class="card">
        <div class="card-header">本日の予約</div>
        <div class="card-body userConsultationNextBody">
            <div v-if="Array.isArray( consultation ) && consultation.length === 0">
                <p class="userConsultationNextNone text-muted mb-0">
                    本日の予約はありません。（<a href="#dashboardUserConsultations">{{ $locale.consultation_host }}予約リストを確認</a>）
                </p>
            </div>
            <div v-else-if="consultation">
                <div @click="showConsultationDetailModal">
                    <div class="doctorMenuContent">
                        <div class="doctorMenuMedicalCourseName">{{ consultation.doctor_menu.medical_course.name }}</div>
                        <div
                            v-if="consultation.doctor_menu.is_health_package"
                            class="doctorMenuHealthPackageIcon">
                            <img src="/images/common/label_health_package1.png">
                        </div>
                        <div class="doctorMenuTitle">{{ consultation.doctor_menu.title }}</div>
                        <div class="doctorMenuConsultationMinutes">
                            <span class="d-block d-md-inline mt-1 mb-1">{{ $locale.consultation_host }}時間:</span>
                            <span>{{ helper.timeForHuman(consultation, user.timezone) }}</span><!--
                         --><span>{{ `（${consultation.doctor_menu.consultation_minutes}分）` }}</span>
                        </div>

                        <hr class="divide">

                        <div class="d-block d-md-flex">
                            <div class="doctorMenuDoctorImage">
                                <img
                                    v-if="consultation.doctor_menu.doctor.presigned_url"
                                    :src="consultation.doctor_menu.doctor.presigned_url">
                                <img
                                    v-else
                                    src="/images/common/profile_default.svg">
                            </div>
                            <div class="doctorMenuDoctorDetail">
                                <div class="doctorMenuDoctorName">
                                    <span>{{ consultation.doctor_menu.doctor.full_name }}</span>
                                    <span v-if="!isStaff">医師</span>
                                </div>
                                <div>
                                    <div
                                        v-for="course in consultation.doctor_menu.doctor.medical_courses"
                                        class="doctorMenuDoctorMedicalCourse">
                                        {{ course.name }}
                                    </div>
                                </div>
                                <a href="#">予約内容の詳細を確認</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="userAgent !== 'web'">
                    <div class="appDlBoxWrapper mt-4">
                        <div class="appDlBoxContent">
                            <p class="appDlBoxText">{{ $locale.consultation_host }}を受けるにはアプリが必要です。事前にインストールをお願いします。</p>
                            <div class="d-flex justify-content-center align-items-center">
                                <a :href="iosAppDownloadUrl" target="_blank">
                                    <img class="appDlBoxImg01" src="/images/common/btn-dl-apple.png">
                                </a>
                                <a :href="androidAppDownloadUrl" target="_blank">
                                    <img class="appDlBoxImg02" src="/images/common/btn-dl-googleplay.png">
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-center align-items-center mt-4">
                    <div class="mr-2 ml-2 flex-grow-1 flex-md-grow-0 ConsultationNextButtonWrapper">
                        <b-button
                            v-if="showCancelBtn && canCancel"
                            variant="yokumiru-orange"
                            @click="showReservationCancelModal(consultation, $event)">
                            {{ $locale.consultation_host }}をキャンセル
                        </b-button>
                    </div>
                    <div class="mr-2 ml-2 flex-grow-1 flex-md-grow-0 ConsultationNextButtonWrapper">
                        <a
                            v-if="isRoomRestricted(consultation)"
                            class="btn btn-yokumiru-doctor"
                            @click="openModalRestrict">
                            {{ $locale.type === 'consul' ? '相談室' : '入室する' }}
                        </a>
                        <a
                            v-else
                            class="btn btn-yokumiru-doctor"
                            :href="`/consultations/${consultation.id}`">
                            {{ $locale.type === 'consul' ? '相談室' : '入室する' }}
                        </a>
                    </div>
                </div>
            </div>
            <div
                v-else
                class="d-flex justify-content-center align-items-center">
                <b-spinner variant="yokumiru-user"></b-spinner>
            </div>
        </div>
    </div>
</template>

<script>
    import constants from '../../constants'
    import moment from 'moment-timezone'
    import YokumiruHelper from "../../YokumiruHelper"

    export default {
        props: {
            user: {
                type: Object,
                default: null,
            },
            userAgent: {
                type: String,
                default: 'web',
            },
        },

        data: function () {
            return {
                helper: YokumiruHelper,
                consultation: null,
                reservation_cancel_allowable_minute: null,
            }
        },

        computed: {
            /**
             * アプリのダウンロードURL（ios）
             */
            iosAppDownloadUrl: function () {
                if (this.$locale.type === 'consul') {
                    return 'https://apps.apple.com/jp/app/id1625616546'
                } else {
                    return 'https://apps.apple.com/jp/app/id1519400662'
                }
            },

            /**
             * アプリのダウンロードURL（android）
             */
            androidAppDownloadUrl: function () {
                if (this.$locale.type === 'consul') {
                    return 'https://play.google.com/store/apps/details?id=jp.realll.consul.yokumiru'
                } else {
                    return 'https://play.google.com/store/apps/details?id=jp.realll.yokumiru'
                }
            },

            /**
             * スタッフ判定
             *
             * @return {boolean}
             */
            isStaff: function () {
                return this.consultation
                    && this.consultation.doctor_menu
                    && this.consultation.doctor_menu.doctor
                    && this.consultation.doctor_menu.doctor.full_name.includes('スタッフ')
            },

            /**
             * 法人会員で利用停止中かどうか
             *
             * @return {boolean}
             */
            isUserPausedCompany: function () {
                if (!this.user || !this.user.groups) {
                    return false
                }

                return !!this.user.groups.find((group) => {
                    return group.flg_paused && group.group_type === constants.groupType.company
                })
            },

            /**
             * 相談キャンセル可能判定
             *
             * @return {boolean}
             */
            canCancel: function () {
                if (!this.consultation || this.consultation.flg_cancel) {
                    return false
                }

                const canStatus = constants.consultations.canCancelAll.includes(this.consultation.status)

                if (this.$store.state.configs.subscription == 1) {
                    return canStatus
                }
                return canStatus && this.isBeforeLimit
            },

            /**
             * キャンセル受付時間判定
             *
             * @return {boolean}
             */
            isBeforeLimit: function() {
                return this.consultation && moment(this.consultation.start_time).diff(moment.now(), "minutes") > this.$store.state.configs.reservation_cancel_allowable_minute
            },

            /**
             * 相談キャンセルボタンの表示判定
             *
             * @return {boolean}
             */
            showCancelBtn: function () {
                if (!this.consultation) {
                    return false
                }
                if (this.consultation.status !== constants.consultations.confirmed) {
                    return true
                }
                return this.$store.state.configs.reservation_cancel_after_confirm_user == 1
            },

            /**
             * 利用制限が何によってかけられているか
             *
             * @return {string|null}
             */
            restrictedBy: function () {
                if (!this.user) return null

                if (this.isUserPausedCompany) {
                    return 'company'
                }

                return null
            },
        },

        created: function () {
            this.fetchConsultation()
            bus.$on('user-reservation-completed', this.fetchConsultation)
            bus.$on('user-reservation-canceled', this.fetchConsultation)
        },

        mounted: function () {
            if (this.setup === 'paid') {
                bus.$emit('alert-success', `お支払いが完了しました。引き続き${this.$locale.appName}をご利用ください。`, 8000)
            }
            else if (this.setup === 'free') {
                bus.$emit('alert-success', `${this.$locale.appName}の利用を開始しました。`, 8000)
            }
        },

        beforeDestroy: function() {
            bus.$off('user-reservation-completed')
            bus.$off('user-reservation-canceled')
        },

        methods: {
            fetchConsultation: function () {
                axios.get(constants.user.consultations.endpoint.next)
                    .then(({data}) => {
                        this.consultation = data
                    } )
            },

            /**
             * 診療予約詳細モーダル表示
             */
            showConsultationDetailModal: function () {
                bus.$emit('open-modal-consultation-detail', this.consultation)
            },

            /**
             * 診療予約キャンセルモーダル表示
             *
             * @param {object} consultation
             * @param {object} event
             */
            showReservationCancelModal: function (consultation, event) {
                event.preventDefault()
                bus.$emit('open-modal-reservation-cancel', this.consultation)
            },

            /**
             * 利用制限判定（入室）
             *
             * @param {object} consultation
             * @return {boolean}
             */
            isRoomRestricted: function (consultation) {
                if (this.isUserPausedCompany) {
                    return true
                }
                return false
            },

            /**
             * 利用制限モーダル表示
             */
            openModalRestrict: function () {
                if (this.restrictedBy === 'company') {
                    bus.$emit(
                        'open-modal-page-transition',
                        '機能をご利用いただけません',
                        '会員様の所属する法人は現在利用停止中です。'
                    )
                }
                else if (this.restrictedBy === 'canceled') {
                    // プラン解約時に有効期限以降の予約は自動キャンセルされるため、通常は通らない
                    bus.$emit(
                        'open-modal-page-transition',
                        'サービスの有効期限を過ぎています',
                        'サービス解約済みのため、入室できません（キャンセルできない場合はサポートセンターまでお問い合わせください）。'
                    )
                }
                else {
                    bus.$emit(
                        'open-modal-page-transition',
                        '未完了のお支払いがあります',
                        '入室する前に、お支払いを完了してください。'
                    )
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
.userConsultationNextNone {
    font-size: 14px;

    a {
        text-decoration: underline;

        &:hover {
            text-decoration: none;
        }
    }
}

.userConsultationNextMobileCaution {
    margin-top: 15px;
    color: #dc3545;
    font-size: 14px;
    font-weight: bold;
    text-align: center;

    a {
        display: inline-block;
        margin: 0 4px;
        text-decoration: underline;
    }
}

.doctorMenuContent {
    cursor: pointer;

    &:hover {
        opacity: 0.7;
    }
}

.doctorMenuMedicalCourseName {
    color: #2A2E31;
    font-size: 14px;
    font-weight: bold;
    line-height: 1.1;
}

.doctorMenuHealthPackageIcon {
    margin: 3px 0 1px;

    img {
        width: 130px;
    }
}

.doctorMenuTitle {
    color: #2A2E31;
    font-size: 23px;
    font-weight: bold;
    line-height: 1.5;
}

.doctorMenuConsultationMinutes {
    color: #7D868D;
    line-height: 1.1;

    span {
        font-size: 14px;
        font-weight: bold;

        &:nth-child(2),
        &:nth-child(3),
        &:nth-child(4) {
            font-size: 19px;
        }

        &:nth-child(5) {
            font-weight: normal;
        }
    }
}

.doctorMenuLabel {
    display: inline-block;
    margin-right: 5px;
    margin-bottom: 5px;
    padding: 2px 12px;
    color: #53A15B;
    font-size: 13px;
    border: 1px solid #DFEDDC;
    background-color: #F3F8F2;
    border-radius: 6px;

    &:last-child {
        margin-right: 0;
    }
}

.doctorMenuDescription {
    color: #757C83;
    font-size: 14px;
    line-height: 21px;
    margin-top: 15px;
}

.divide {
    border-top: 1px dotted #ABB3BA;
}

.doctorMenuDoctorImage {
    position: relative;
    overflow: hidden;
    width: 120px;
    min-width: 120px;
    height: 120px;
    border-radius: 50%;

    img {
        object-fit: cover;
        width: 100%;
        height: 100%;
    }
}

.doctorMenuDoctorName {
    color: #2A2E31;
    font-weight: bold;

    span {
        font-size: 21px;

        &:nth-child(2) {
            font-size: 14px;
        }
    }
}

.doctorMenuDoctorDetail {
    margin: 5px 0 0 32px;

    @media screen and (max-width: 767px) {
        margin-left: 0;
    }

    a {
        display: block;
        margin-top: 2px;
        font-size: 14px;
        text-decoration: underline;
    }
}

.doctorMenuDoctorMedicalCourse {
    display: inline-block;
    color: #7D868D;
    font-size: 14px;
    font-feature-settings: 'palt';
    line-height: 1;

    &::after {
        content: '、';
    }

    &:last-child {
        &::after {
            display: none;
        }
    }
}

.doctorMenuDoctorLabel {
    display: inline-block;
    margin-right: 5px;
    margin-bottom: 5px;
    padding: 2px 12px;
    color: #B49834;
    font-size: 13px;
    border: 1px solid #EDECDC;
    background-color: #F7F8F2;
    border-radius: 6px;

    &:last-child {
        margin-right: 0;
    }
}

.doctorMenuDoctorHistory {
    color: #757C83;
}

.doctorMenuDoctorHistoryTitle {
    font-weight: bold;
}

.doctorMenuDoctorLicense {
    color: #757C83;
}

.doctorMenuDoctorLicenseTitle {
    font-weight: bold;
}

.appDlBoxWrapper {
    width: 100%;
    padding: 18px 15px;
    background: #eceff1;
    border-radius: 3px;

    .appDlBoxContent {
        .appDlBoxText {
            color: #333;
            font-size: 14px;
            text-align: center;
        }

        a {
            text-decoration: none;
        }

        .appDlBoxImg01,
        .appDlBoxImg02 {
            width: 180px;
            margin: 0 11px;

            @media screen and (max-width:767px) {
                width: 120px;
                margin: 0 6px;
            }
        }
    }
}

.ConsultationNextButtonWrapper {
    button, a {
        @media screen and (max-width:767px) {
            width: 100%;
        }
    }
}
</style>
